import { ChakraV3, Empty } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { BiSolidBarChartAlt2 } from 'react-icons/bi';
import { ECharts } from '../../../../components/generic/ECharts';
import type { UseTimeseriesChartReturn } from '../../hooks/useTimeseriesChart';

interface Props {
  chart: UseTimeseriesChartReturn;
}

export const TimeSeriesChartWidgetContent = (props: Props) => {
  const { chart } = props;

  const content = P.run(() => {
    if (P.isEmpty(chart.widget.series ?? [])) {
      return (
        <ChakraV3.Stack h='full' w='full' align='center' justify='center' textAlign='center'>
          <Empty
            title='No series added'
            description='Add series to view them in the chart. Series are used to display data on the chart.'
            icon={
              <ChakraV3.Icon size='2xl' color='gray.300'>
                <BiSolidBarChartAlt2 />
              </ChakraV3.Icon>
            }
          />
        </ChakraV3.Stack>
      );
    }

    return <ECharts ref={chart.ref} options={chart.options} onChartReady={chart.onChartReady} />;
  });

  return (
    <ChakraV3.Stack h='full' w='full' overflow='hidden' userSelect='none'>
      {content}
    </ChakraV3.Stack>
  );
};
